import React, { useCallback, useEffect, useRef, useState } from "react";
import EquipoService from "../../services/Iperc/EquipoService";
import { IComboBox, IComboBoxOption } from "@fluentui/react";

export const useComboEquipoIperc = () => {
  const [filter, setFilter] = useState({ search: "" });
  const [dataComboEquiposIperc, setDataComboEquiposIperc] = useState<
    IComboBoxOption[]
  >([]);

  const comboBoxRefEquipoIPERC = useRef<IComboBox>(null!);

  const _openOptionEquipoIPERC = useCallback(() => {
    comboBoxRefEquipoIPERC.current?.focus(true);
  }, []);

  const _onKeyUpSearchEquipoIperc = (event: React.KeyboardEvent<IComboBox>) => {
    if (event.code === "Escape") {
      comboBoxRefEquipoIPERC.current?.focus(false);
    } else {
      _openOptionEquipoIPERC();
      let { value } = event?.target as HTMLInputElement;
      setFilter({ ...filter, search: value });
    }
  };

  const onClickComboBoxEquipoIPERC = () => {
    comboBoxRefEquipoIPERC.current?.focus(true);
  };
  const postComboEquiposIperc = () => {
    EquipoService.postListarComboEquipo(filter).then((res) => {
      if (res.status === 200) {
        setDataComboEquiposIperc(res.data);
      }
    });
  };

  useEffect(() => {
    postComboEquiposIperc();
  }, [filter]);

  return {
    dataComboEquiposIperc,
    comboBoxRefEquipoIPERC,
    _openOptionEquipoIPERC,
    _onKeyUpSearchEquipoIperc,
    onClickComboBoxEquipoIPERC,
  };
};
